import { Measurements, MeasurementConversions } from './enums'

export const formatMeasurement = (measurement: number, units: string, hasSubUnits = true): string => {
  if (measurement < 0) return ''

  if (measurement > 2000 && units === 'metric' && !hasSubUnits) {
    return `${Math.round(measurement * MeasurementConversions.INCH_TO_METERS)}${Measurements.METERS}`
  } else if (measurement > 2000 && units === 'metric') {
    return `${(measurement * MeasurementConversions.INCH_TO_METERS).toFixed(2)}${Measurements.METERS}`
  } else if (measurement > 2000) {
    return `${Math.round(measurement / MeasurementConversions.INCH_TO_YARDS)}${Measurements.YARDS}`
  }

  if (units === 'metric' && !hasSubUnits) {
    return `${Math.round(measurement * MeasurementConversions.INCH_TO_METERS)}${Measurements.METERS}`
  } else if (units === 'metric') {
    return `${(measurement * MeasurementConversions.INCH_TO_METERS).toFixed(2)}${Measurements.METERS}`
  }
  return `${Math.floor(measurement / MeasurementConversions.INCH_TO_FEET)}${Measurements.FEET} ${Math.round(
    measurement % MeasurementConversions.INCH_TO_FEET,
  )}${Measurements.INCHES}`
}
